import React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { IconButton } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
    table: {},
    wrapIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex',
      cursor: 'pointer',
    },
    iconButton: {
      verticalAlign: 'middle',
      display: 'inline-flex',
      padding: '0px 12px',
    },
  })
);

export interface IPopoverGeneric {
  type: 'MouseOver' | 'IconButton';
  iconForButton?: React.ReactNode;
  displayValue?: any;
  showPopover?: boolean;
  showPopoverIcon?: boolean;
  anchorOrigin?: {
    vertical: 'top' | 'center' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  transformOrigin?: {
    vertical: 'top' | 'center' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  popoverTitle?: string;
  popoverData: React.ReactNode;
  onHandleClick?: any;
}

export function PopoverGeneric({
  type,
  iconForButton = <InfoIcon />,
  displayValue = '',
  showPopover = false,
  showPopoverIcon = false,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'left',
  },
  popoverTitle = '',
  popoverData,
  onHandleClick,
}: IPopoverGeneric) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onHandleClick?.(event);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (showPopover === false) {
    return <span />;
  } else {
    return (
      <span>
        {type === 'MouseOver' && (
          <Typography
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handleClose}
            className={classes.wrapIcon}
          >
            {displayValue}&nbsp;
            {showPopoverIcon && <InfoIcon color="primary" />}
          </Typography>
        )}
        {type === 'IconButton' && (
          <IconButton
            color="primary"
            aria-label="Show Chart"
            className={classes.iconButton}
            onClick={handleClick}
            size="large"
          >
            {iconForButton}
          </IconButton>
        )}
        <Popover
          id="generic-popover"
          className={type === 'MouseOver' ? classes.popover : ''}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          onClose={handleClose}
          anchorEl={anchorEl}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          disableRestoreFocus
        >
          {popoverTitle?.length > 0 && (
            <Typography variant="h6" align="center">
              {popoverTitle}
            </Typography>
          )}
          {popoverData}
        </Popover>
      </span>
    );
  }
}
